// Persisted task status (ITask.status).
export enum TaskStatus {
    Unassigned          = 0,
    Open                = 1,
    InProgress          = 2,
    Waiting             = 3,
    SentForConfirmation = 4,
    Confirmed           = 5,
    Invoiced            = 6,
}

// The three task lists of the menu, each backed by its own GET /tasks/<list>.
export enum TaskList {
    Open           = 'open',
    InConfirmation = 'inConfirmation',
    Finished       = 'finished',
}
